import {Checkbox ,Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControlLabel, FormControl, Stack, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useState } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import enAU from 'date-fns/locale/en-AU';
import { Action as Managed } from "../../features/db/action";

export default function NewActionDialog(props)
{
	const {variant} = props;
	const {submitCallback} = props;
	const [open, setOpen] = useState(false);

	const handleClick = ()=>{
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [name, setName] = useState("");
	const handleNameChange = (e)=>
	{
		setName(e.target.value);
	}

	const [status, setStatus] = useState(false);
	const handleStatusChange = ()=>{
		setStatus(!status);
	}

	const [errorReason,setErrorReason] = useState("");
	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = ()=>
	{
		setErrorReason("");
		setOpenErrorSnack(false);
	}

	const makeError = (reason)=>{
		setErrorReason(reason);
		setOpenErrorSnack(true);
	}

	const handleSubmit=()=>
	{
		if(name==="")
		{
			makeError("NO ACTION ENTERED!");
			return;
		}
		if(name.includes("/"))
		{
			makeError("NAME CANNOT CONTAIN / !");
			return;
		}
		const p = new Managed(name,status);
		p.submitAsNew().then(submitCallback(p));
		handleClose();
	}

	return (
		<>
		<Button onClick={handleClick} variant={variant}>New Action</Button>
		<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="error">
					{errorReason}
				</MuiAlert>
		</Snackbar>
		<Dialog onClose={handleClose} open={open}>
			<DialogTitle>Create A New Action</DialogTitle>
			<DialogContent>
				<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enAU}>
					<FormControl>
						<Stack spacing={{ xs: 1, sm: 2, md: 4 }}>
						<TextField
							autoFocus
							margin="dense"
							label="Action Name"
							fullWidth
							variant="outlined"
							onChange={handleNameChange}
						/>
						<FormControlLabel
							control={<Checkbox checked={status} />} 
							label="Chemical Use [Yes / No]"
							labelPlacement="end"
							onChange={handleStatusChange}
						/>
						</Stack>
					</FormControl>
				</LocalizationProvider>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit} variant='contained'>Submit</Button>
			</DialogActions>
		</Dialog>
		</>
	);
}